import React, { useState } from 'react';
import { Box, Button, Typography, Stack, Paper } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { OneCommTotalPendingTransactions } from '../../interfaces/ProducerDashboard';
import OneCommTransactionsModal from './OneCommTransactionsModal';

interface Props {
    data: OneCommTotalPendingTransactions;
    currency: string;
}

export default function DashboardTransactions({ data, currency }: Props) {
    const [open, setOpen] = useState(false);

    if (!data || data.total_count === 0) return null;

    return (
        <>
            <Paper
                variant="outlined"
                sx={{
                    p: 1.5, mb: 3, borderRadius: '4px', bgcolor: '#fafafa', border: '1px solid #eee',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between'
                }}
            >
                <Stack direction="row" spacing={2} alignItems="center">
                    <InfoOutlinedIcon sx={{ color: 'text.disabled', fontSize: 20 }} />
                    <Box>
                        <Typography sx={{ fontWeight: 800, fontSize: '0.8rem', color: 'text.primary' }}>
                            Account Pending Movements
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                            {data.total_count} transactions awaiting transfer.
                        </Typography>
                    </Box>
                </Stack>

                <Stack direction="row" spacing={4} alignItems="center">
                    <Button
                        variant="outlined"
                        color="inherit"
                        size="small"
                        onClick={() => setOpen(true)}
                        sx={{
                            fontWeight: 700,
                            textTransform: 'none',
                            fontSize: '0.7rem',
                            borderColor: '#e0e0e0',
                            bgcolor: '#fff',
                            '&:hover': { bgcolor: '#f5f5f5', borderColor: '#bdbdbd' }
                        }}
                    >
                        View Details
                    </Button>
                </Stack>
            </Paper>

            <OneCommTransactionsModal
                open={open}
                onClose={() => setOpen(false)}
                data={data}
                currency={currency}
                title="Global Account Pending Transfers"
                subtitle="Aggregated stats for all operators"
            />
        </>
    );
}